import { useParams, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Nav from "@/components/site/Nav";
import { NOURISH_TOPICS } from "@/data/diet";

export default function NourishTopic() {
  const { topic } = useParams();
  const t = NOURISH_TOPICS[topic];
  if (!t) return <Navigate to="/diet" replace />;
  return (
    <div className="min-h-screen bg-[#F7F5F0] text-[#2D372B]">
      <Nav />
      <header className="max-w-3xl mx-auto px-6 pt-32 md:pt-44 pb-10">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
          <div className="overline mb-3">{t.kicker}</div>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl tracking-tighter" data-testid="nourish-topic-title">{t.title}</h1>
          <p className="mt-5 text-[#5C665A] leading-relaxed text-base md:text-lg">{t.intro}</p>
        </motion.div>
      </header>
      <section className="max-w-3xl mx-auto px-6 pb-16 space-y-6">
        {t.points.map(([h, d], i) => (
          <motion.div key={h} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
            className="bg-white border border-[#E5E2D9] rounded-2xl p-7">
            <div className="font-serif-display text-2xl mb-2">{h}</div>
            <p className="text-sm md:text-base text-[#5C665A] leading-relaxed">{d}</p>
          </motion.div>
        ))}
        <div className="bg-[#2D372B] rounded-3xl p-8 md:p-10 text-center">
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#A9B39D]">JAY DIETS™</div>
          <h2 className="font-serif-display text-2xl md:text-3xl text-[#F7F5F0] mt-2">Want a plan built around you?</h2>
          <p className="text-sm text-[#C9CFC0] mt-3 max-w-md mx-auto">Personalised, adaptive nutrition — powered by JAY 7™ and human coaching.</p>
          <a href="/diet#programmes" data-testid="nourish-topic-cta" className="mt-6 inline-flex items-center gap-2 rounded-full px-8 py-3.5 bg-[#C57B57] text-white font-medium hover:bg-[#AD6A48] transition-colors">
            Explore JAY Programmes <ArrowRight size={15} />
          </a>
        </div>
      </section>
    </div>
  );
}
